'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { List } from 'immutable';
import { fetchTrackingStatuses } from 'AdsUI/data/TrackingStatusData';
import useTrackingErrorModal from 'AdsUI/lib/useTrackingErrorModal';
import GlobalFiltersRecord from 'AdsUI/records/reporting/GlobalFiltersRecord';
import BaseTrackingErrorModal from 'AdsUI/components/tracking-error-modal/BaseTrackingErrorModal';

const AccountTrackingErrorModal = ({
  allTrackingErrors,
  globalFilters,
  onClose
}) => {
  const fetchStatuses = useCallback(() => fetchTrackingStatuses(globalFilters), [globalFilters]);
  const {
    loading,
    groupedStatuses
  } = useTrackingErrorModal(fetchStatuses, allTrackingErrors);
  return /*#__PURE__*/_jsx(BaseTrackingErrorModal, {
    loading: loading,
    onClose: onClose,
    groupedStatuses: groupedStatuses
  });
};

AccountTrackingErrorModal.propTypes = {
  allTrackingErrors: PropTypes.instanceOf(List).isRequired,
  globalFilters: PropTypes.instanceOf(GlobalFiltersRecord).isRequired,
  onClose: PropTypes.func.isRequired
};
export default AccountTrackingErrorModal;